import { lazy } from "react";
import { IGaiaObjectOverviewProps } from "./definitions";

const LazyGaiaObjectOverview = lazy(() => import("./GaiaObjectOverview"));

const GaiaObjectOverview = (props: IGaiaObjectOverviewProps) => (
  <LazyGaiaObjectOverview {...props} />
);

export default GaiaObjectOverview;
